import classnames from 'classnames';
import Link from 'next/link';
import Router from 'next/router';
import React from 'react';
import BackArrowIcon from './back-arrow.svg';
import styles from './styles.scss';

interface Props {
  text: string;
  className?: string;
  hover?: boolean;
  colorBlue?: boolean;
  removeArrow?: boolean;
  href: string;
  as: string;
  useHistoryBack?: boolean;
}

const BackButton = ({
  text,
  className,
  hover,
  href,
  as,
  colorBlue,
  removeArrow,
  useHistoryBack,
}: Props): JSX.Element => {
  return (
    <Link href={href} as={as}>
      <a
        className={classnames(
          styles.button,
          hover && styles.hover,
          colorBlue && styles.blueButton,
          removeArrow && styles.removeArrow,
          className && className,
        )}
        onClick={(e): void => {
          if (useHistoryBack) {
            e.preventDefault();
            Router.back();
          }
        }}
      >
        <BackArrowIcon />
        {text}
      </a>
    </Link>
  );
};

BackButton.defaultProps = {
  useHistoryBack: false,
};

export default BackButton;
